/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import moment from 'moment';
import Modal from '/client/src/components/Modal';
import Loader from '/client/src/components/Loader';
import { format } from '/client/src/utils/amountTransformation';

import './styles.scss';
import { currency } from '/client/src/constants';
import { convertToLocalTime } from '/client/src/utils/jstz';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';


type PropsType = {
  isOpen: boolean,
  handleShowPaymentPurchaseModal: (boolean) => void,
  showPaymentModalOrderId: null | number | string
};

class EventPageDetailCustomersPaymentPurchaseModal extends React.Component<PropsType> {
  static contextType = EventDetailContainerContext;

  state = {
    data: null
  }

  handleClose = (): any => {
    const { handleShowPaymentPurchaseModal } = this.props;

    handleShowPaymentPurchaseModal(false);
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      this.setState({
        data: _.get(response, 'data.result', [])
      });
    }
  }

  render(): React.Element {
    const { isOpen, showPaymentModalOrderId } = this.props;
    const { data } = this.state;
    // eslint-disable-next-line camelcase
    const time_zone_id = _.get(this.context, 'eventDetail.time_zone_id', '');

    let subtotal = 0;

    let tax = 0;

    let fee = 0;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div
          className="modal-dialog customModal EventPageDetailCustomersModal EventPageDetailCustomersPaymentPurchaseModal modal-table-filter"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                <span>Receipt Summary</span>
              </h4>
            </div>
            <div className="modal-body">
              <Loader
                url={`/api/v1/1/orders/${showPaymentModalOrderId}`}
                onLoaded={this.handleLoaded}
              >
                {data &&
                  <>
                    <ul>
                      <li>
                        <span>Purchaser:</span>
                        <span>{data.customer_first_name} {data.customer_last_name}</span>
                      </li>
                      {data.paid_time_utc &&
                        <>
                          <li>
                            <span>Date</span>
                            <span>{convertToLocalTime(data.paid_time_utc, time_zone_id, 'MM/DD/YYYY')}</span>
                          </li>
                          <li>
                            <span>Time</span>
                            <span>{convertToLocalTime(data.paid_time_utc, time_zone_id, 'hh:mm a z')}</span>
                          </li>
                        </>
                      }
                      <li>
                        <span>Card</span>
                        <span>XXXX-XXXX-XXXX-{data.card_last4}</span>
                      </li>
                    </ul>

                    {_.map(data.order_ticket_items, (t: {}, ti: number): React.Element => {
                      subtotal = subtotal + t.price * t.quantity;

                      if (t.fee_to_customer > 0) fee = fee + t.fee_to_customer * t.quantity;

                      if (t.tax > 0) tax = tax + t.tax * t.quantity;

                      return (
                        <ul key={`EventPageDetailCustomersPaymentPurchaseModal-order_ticket_items-${ti}`}>
                          <li className='ticketName'>
                            <div><b>{t.quantity}x</b> {t.ticket_snapshot.name}</div>
                            <div>{format(currency[data.currency], t.price * t.quantity)}</div>
                          </li>
                        </ul>
                      );
                    })}

                    {data.donation_amount > 0 &&
                      <ul>
                        <li>
                          <div>Donation</div>
                          <div>{format(currency[data.currency], data.donation_amount)}</div>
                        </li>
                      </ul>
                    }

                    <ul>
                      <li>
                        <span>Subtotal</span>
                        <span>{format(currency[data.currency], subtotal)}</span>
                      </li>
                      <li>
                        <span>Tax</span>
                        <span>{format(currency[data.currency], tax)}</span>
                      </li>
                      <li>
                        <span>Service Fee</span>
                        <span>{format(currency[data.currency], fee)}</span>
                      </li>
                      {data.discount_amount > 0 &&
                        <li>
                          <span>Discount</span>
                          <span>-{format(currency[data.currency], data.discount_amount)}</span>
                        </li>
                      }
                      <li>
                        <span className='total'>Total</span>
                        <span>
                          {format(
                            currency[data.currency],
                            subtotal + tax + fee + data.donation_amount - data.discount_amount
                          )}
                        </span>
                      </li>
                    </ul>
                  </>
                }
              </Loader>
            </div>
            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EventPageDetailCustomersPaymentPurchaseModal;
